import React from "react";
import axios from "axios";
import { useState, useEffect, useMemo } from "react";
import MaterialReactTable from "material-react-table";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faPencil,  faTrashAlt } from '../../../node_modules/@fortawesome/free-solid-svg-icons/index';

const CropStages = () => {
  const [value, setvalue] = useState("");
  const [cropStageData, setcropStageData] = useState([]);
  const [flag, setFlag] = useState(false);
  const [cropStageValue, setCropStageValue] = useState("");
  const [deleteCode, setDeleteCode] = useState({});
  const [editCode, setEditCode] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const result = await axios(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/cropstage`
    );
    setcropStageData(result.data.dataContent);
  };

  // useEffect(() => {
  //   if (flag === true) {
  //     fetchData();
  //   }
  // }, [flag]);

  const columns = useMemo(
    () => [
      {
        header: "S.No",
        Cell: (cell) => Number(cell.row.id) + 1,
      },
      {
        accessorKey: "cropStageName",
        header: "Crop Stages Name",
      },
      {
        accessorKey: "visibility",
        header: "Visibility",
      },
      {
        accessor: "",
        header: "Actions",
        Cell: (cell) => (
          <>
            <i
              className="btn text-primary"
              type="button"
              onClick={() => handleEditCropStage(cell.row.original)}
            >
              <FontAwesomeIcon icon={faPencil} />
            </i>
            <i
              className="btn text-danger"
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#myDelete"
              onClick={() =>
                setDeleteCode({
                  CropStageCode: cell.row.original.cropStageCode,
                })
              }
            >
              {" "}
              <FontAwesomeIcon icon={faTrashAlt} />
            </i>
          </>
        ),
      },
    ],
    []
  );

  function removed() {
    var mpopup = document.getElementById("mpopupBox");
    mpopup.style.display = "none";
    setCropStageValue("");
  }

  function removedAdd() {
    var mpopup = document.getElementById("addNewCropStage");
    mpopup.style.display = "none";
    setCropStageValue("");
  }

  function handleEditCropStage(value) {
    document.getElementById("cropStageEdit").value = value.cropStageName;

    // localUserTypeName = value.userTypeName
    // document.getElementById("userTypeEdit").defaultValue= ""
    // document.getElementById("userTypeEdit").defaultValue = value.userTypeName;
    setEditCode({
      CropStageCode: value.cropStageCode,
      CropStageName: value.cropStageName,
    });
    //   setUserTypeValue(value.seasonName)
    var x = document.createElement("a");
    x.id = "mpopupLink";
    var mpopup = document.getElementById("mpopupBox");
    mpopup.style.display = "block";
  }

  function AddNewCropStage() {
    if (cropStageValue) {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        createdByUC: localStorage.getItem("userCodeGlobal"),
        cropStageName: cropStageValue,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/cropstage`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          alert(JSON.parse(result).message);
          //   $('#addNewBtn').on('click', function () {
          // $('#addNewUserType').modal('hide');
          //  })
          if (JSON.parse(result).success === true) {
            // $('#addNewBtn').on('click', function () {
            // $('#addNewUserType').modal('hide');
            // })

            // setFlag(true);
            setCropStageValue("");
            fetchData()
            removedAdd()
          }
        })
        .catch((error) => console.log("error", error));
    } else {
      alert("Enter Crop Stage Name");
    }
  }

  function deleteData(value) {

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify(deleteCode);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };

    fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/cropstage`, requestOptions)
        .then(response => response.text())
        .then(result => {
            if (JSON.parse(result).success === true) {
                fetchData()

            }
        })
        .catch(error => console.log('error', error));
}

function EditCropStage() {
       
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
        "modifiedByUC": localStorage.getItem("userCodeGlobal"),
        "cropStageCode": editCode.CropStageCode,
        "cropStageName": cropStageValue,
        "visibility": "Y"
      
    });

    var requestOptions = {
        method: 'PUT',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };

    fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/cropstage`, requestOptions)
        .then(response => response.text())
        .then(result => {
            alert(JSON.parse(result).message)
            if (JSON.parse(result).success === true) {
                setCropStageValue("")
                fetchData()
                removed()


            }
        }
        )
        .catch(error => console.log('error', error));
       
}

function handleCropStageValue(value) {
    console.log("value@@", value)
    const valueFinal = value.replace(/[^a-z0-9 ]/gi, "");
    document.getElementById("cropStageEdit").value = valueFinal;
    setCropStageValue(valueFinal)
}

function handleAddNewData() {
  setCropStageValue("");
  setFlag(false)
}

  return (
    <>
      <main id="main" className="main">
      <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
         
          <nav>
          <h1>Crop Stages</h1>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">Master</li>
              <li className="breadcrumb-item active">Crop Stages</li>
            </ol>
          </nav>
          <button
            type="button"
            className="btn btn-success"
            data-bs-toggle="modal"
            data-bs-target="#addNewCropStage"
            onClick={() => handleAddNewData()}
          >
            Add New
          </button>
        </div>
        <section className="section">
          <div className="row justify-content-lg-center">
            <div className="col-lg-12 ">
              <div className="card">
                <MaterialReactTable
                  columns={columns}
                  data={cropStageData}
                  enableColumnOrdering
                  enablePagination={true}
                />
              </div>
            </div>

            <div className="col-lg-6"></div>
          </div>
          <div className="modal" id="addNewCropStage">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                <label for="add_season" className="form-label">
                    Add New Crop Stage
                  </label>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                  >
                    X
                  </button>
                </div>

                <div className="modal-body">
                <label for="add_season" className="form-label">
                    Crop Stage Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Add New "
                    onChange={(e) => handleCropStageValue(e.target.value)}
                    value={cropStageValue}
                    maxLength={50}
                  />
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-success"
                    // id="addNewBtn"
                    // data-bs-dismiss="modal"
                    onClick={AddNewCropStage}
                  >
                    Add
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div id="mpopupBox" className="modal">
            <div className="modal-content">
              <div className="modal-header">
                <h2>Edit Crop Stage</h2>
              </div>
              <div className="madal-body" id="modal-content">
              <label for="add_season" className="form-label">
                    Crop Stage Name
                  </label>
                <input
                  type="text"
                  className="form-control"
                  id="cropStageEdit"
                  placeholder=""
                  onChange={(e) => handleCropStageValue(e.target.value)}
                  maxLength={50}
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  data-bs-dismiss="modal"
                  onClick={EditCropStage}
                >
                  Add
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  onClick={removed}
                >
                  Close
                </button>
              </div>
            </div>
          </div>

          <div className="modal" id="myDelete">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                  >
                    X
                  </button>
                </div>

                <div className="modal-body">
                  <p>Are you sure you want to delete this item?</p>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-success"
                    data-bs-dismiss="modal"
                    onClick={deleteData}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default CropStages;
